import * as React from 'react';
export const MYSvg = React.forwardRef(function MYSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#E25950',
      d: 'M14 14H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F6F9FC',
      d: 'M0 3.091h16v1.091H0zm0 2.182h16v1.091H0zm0 2.182h16v1.091H0zm0 2.181h16v1.091H0zm0 2.182h16v1.091H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#E25950',
      d: 'M14 14H2a2 2 0 0 1-2-2V8h1v4a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H8V2h6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z',
      opacity: 0.1,
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#43458B',
      d: 'M0 8.55V3.871C0 2.838.796 2 1.778 2H8v6.55H0Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#FCD669',
      fillRule: 'evenodd',
      d: 'M4 3.543a1.75 1.75 0 1 0 0 3.464 2 2 0 1 1 0-3.464Zm2 2.732a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z',
      clipRule: 'evenodd',
    }),
  );
});
MYSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var MY = {
  category: 'flag',
  colorable: false,
  name: 'MY',
  svg: MYSvg,
};
